const MEDICARE_NUMBER_WEIGHTS = [1, 3, 7, 9, 1, 3, 7, 9];

export function isValidMedicareNumber(digits) {
  if (!/^[2-6]\d{8}[1-9]$/.test(digits)) {
    return false;
  }

  const sum = MEDICARE_NUMBER_WEIGHTS.reduce(
    (acc, weight, i) => acc + weight * Number(digits[i]),
    0,
  );

  return sum % 10 === Number(digits[8]);
}
